<div *ngIf="isAdmin"  class="tab-container">
<ul class="nav nav-tabs" role="tablist">
  <li role="presentation" class="nav-item active">
  <a (click)="func()" aria-controls="home" role="tab" data-toggle="tab">
	{{'FRONT_USER.WORKSPACE.MY_Unread_MESSAGES'| translate}}</a></li>
  <li role="presentation" class="nav-item">
    <a (click)="func()" aria-controls="home" role="tab" data-toggle="tab">
    {{'FRONT_USER.WORKSPACE.MY_MESSAGES'| translate}}</a></li>
  </ul>
<div *ngIf="isUnread">
      <app-my-Unreadmessages></app-my-Unreadmessages>
</div>
<div *ngIf="!isUnread">
  <app-my-messages></app-my-messages>
  </div>
</div>
<div *ngIf="!isAdmin">
  <app-my-messages></app-my-messages>
</div>
